import type { OnexData } from "../index.js";
import { nexus } from "../../../exports/nexus.js";

const { assignments } = nexus().onex;
const $brand = Symbol("customAssignments");

const thisOrData = (data: unknown): OnexData | undefined =>
  !!data && typeof data === "object" && $brand in data
    ? (data[$brand] as OnexData)
    : assignments.get();

/**
 *
 *
 *
 */
export type OnexThisObject = { [$brand]: OnexData };

/**
 *
 *
 *
 *
 */
export function customAssignments(data: OnexData): OnexThisObject {
  return { [$brand]: data };
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function isOnexVariant(
  this: unknown | void | OnexThisObject,
  onexId: string,
  variantId: string,
): boolean {
  const data = thisOrData(this);
  if (!data) return false;

  const variant = data?.[onexId];
  return !!variant && variant === variantId;
}

/*                                                */
export const isOnexGroup = isOnexVariant; /*                     */

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function mapOnexVariant<OnexMap extends Record<string, unknown>, D = undefined>(
  this: unknown | void | OnexThisObject,
  onexId: string,
  variantMap: OnexMap,
  ...a: undefined extends D ? [] : [defaultValue: D]
): OnexMap[keyof OnexMap] | D {
  const data = thisOrData(this);
  if (!data) return a[0] as D;

  const variant = data[onexId];
  if (!variant || variantMap[variant] === undefined) return a[0] as D;
  return variantMap[variant] as OnexMap[keyof OnexMap];
}

/*                                                 */
export const mapOnexGroup = mapOnexVariant; /*                     */

/**
 *
 */
export interface WithOnex {
  /**
 *
 *
 *
 */
  isVariant: (variantId: string) => boolean;

  /**
 *
 *
 *
 *
 */
  mapVariant: <OnexMap extends Record<string, unknown>, D = undefined>(
    variantMap: OnexMap,
    ...a: undefined extends D ? [] : [defaultValue: D]
  ) => OnexMap[keyof OnexMap] | D;

  /*                                            */
  isGroup: (variantId: string) => boolean;

  /*                                             */
  mapGroup: <OnexMap extends Record<string, unknown>, D = undefined>(
    variantMap: OnexMap,
    ...a: undefined extends D ? [] : [defaultValue: D]
  ) => OnexMap[keyof OnexMap] | D;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function withOnex(this: unknown | void | OnexThisObject, onexId: string): WithOnex {
  const isVariant: WithOnex["isVariant"] = (variantId) =>
    isOnexVariant.call(this, onexId, variantId);

  const mapVariant: WithOnex["mapVariant"] = (variantMap, ...a) =>
    mapOnexVariant.apply(this, [onexId, variantMap, ...a] as never) as never;

  return {
    isGroup: isVariant,
    mapGroup: mapVariant,
    isVariant,
    mapVariant,
  };
}
